/* ══════════════════════════════════════
           SHOPIFY CONFIG
        ══════════════════════════════════════ */
        // ══ SHOPIFY CREDENTIALS ══
        // Admin API key: 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 (Admin API — NOT used here directly)
        // IMPORTANT: Replace DOMAIN with your real .myshopify.com store domain.
        // Replace TOKEN with your Storefront Access Token (different from Admin key):
        //   Shopify Admin → Apps → Develop Apps → [Your App] → API credentials → Storefront API access tokens
        const DOMAIN = '127654-3.myshopify.com'; // ← UPDATE THIS to your real store domain
        const TOKEN = 'c849c1d64479d113a38c9a49c2ed7096'; // ← UPDATE THIS to your Storefront Access Token
        const API = `https://${DOMAIN}/api/2024-01/graphql.json`;
        const ACCT = `https://${DOMAIN}/account`;

        function goAccount() { window.location.href = ACCT + '/login'; }
        function goAccountOrders() { window.location.href = ACCT + '/orders'; }

        async function gql(query, vars = {}) {
            try {
                console.debug('[Shopify] →', API, vars);
                const r = await fetch(API, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
                    body: JSON.stringify({ query, variables: vars })
                });
                console.debug('[Shopify] HTTP', r.status, r.statusText);
                if (!r.ok) {
                    console.error(`Shopify API error: HTTP ${r.status} — check DOMAIN and TOKEN`, 'Domain:', DOMAIN);
                    return null;
                }
                const j = await r.json();
                console.debug('[Shopify] raw response:', JSON.stringify(j).slice(0, 500));
                if (j.errors) {
                    console.error('Shopify GQL errors:', j.errors);
                    if (j.errors.some(e => e.extensions?.code === 'ACCESS_DENIED' || e.message?.includes('access'))) {
                        console.error('⚠ Storefront Access Token invalid or missing Storefront API permissions.');
                    }
                }
                // Log product count if this is a products query
                if (j.data?.products) {
                    console.log(`[Shopify] products returned: ${j.data.products.edges?.length ?? 0}, hasNextPage: ${j.data.products.pageInfo?.hasNextPage}`);
                }
                return j.data;
            } catch (e) {
                console.error('Shopify fetch failed:', e.message, '— Domain:', DOMAIN);
                return null;
            }
        }

        /* ══════════════════════════════════════
           CURRENCY — DEFAULT USD
        ══════════════════════════════════════ */
        let SHOP_CUR = 'USD';
        let cur = { code: 'USD', sym: '$', label: 'USD $' }; // display currency (user-selected)

        let RATES = {
            USD: 1, INR: 83.5, GBP: 0.79, EUR: 0.92,
            AUD: 1.53, CAD: 1.36, JPY: 149.5, SGD: 1.34, AED: 3.67
        };

        // Maps display currency code → Shopify @inContext country code
        // Must be defined HERE (before the IIFE calls loadProducts) to avoid TDZ ReferenceError
        const CURRENCY_COUNTRY = {
            USD: 'US', INR: 'IN', GBP: 'GB', EUR: 'DE', AUD: 'AU',
            CAD: 'CA', JPY: 'JP', SGD: 'SG', AED: 'AE'
        };

        async function loadRates() {
            try {
                const r = await fetch('https://open.er-api.com/v6/latest/USD');
                if (!r.ok) throw new Error();
                const d = await r.json();
                if (d.rates) RATES = { ...d.rates, USD: 1 };
            } catch (e) { console.warn('Using fallback FX rates'); }
        }

        function fmtP(shopAmt) {
            if (shopAmt == null || isNaN(+shopAmt)) return '';
            const amt = +shopAmt;
            // Prices are fetched from Shopify via @inContext in the selected display currency.
            // No client-side conversion needed — just format with the correct symbol.
            const noDecimal = ['JPY', 'KRW', 'IDR', 'VND'];
            if (noDecimal.includes(cur.code)) return cur.sym + Math.round(amt).toLocaleString('en-US');
            return cur.sym + (Math.round(amt * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        }

        function toggleCur() {
            const d = document.getElementById('curDrop');
            d.classList.toggle('open');
        }
        document.addEventListener('click', e => {
            const w = document.querySelector('.cur-wrap');
            if (w && !w.contains(e.target)) document.getElementById('curDrop').classList.remove('open');
        });
        function setCur(code, sym, label) {
            cur = { code, sym, label };
            document.getElementById('curBtn').textContent = label;
            document.getElementById('curDrop').classList.remove('open');
            document.querySelectorAll('.cur-opt').forEach(o => o.classList.toggle('on', o.textContent.trim().startsWith(code)));
            if (!PRODUCTS.length) return;
            // ── Refresh ALL pages that display prices ──
            renderGrid(activeFilter);          // home page grid
            applyFilters();                    // collection / all-products page
            renderSearchPage();                // search page
            renderWishlist();                  // wishlist page
            renderCartUI();                    // cart + subtotal
            // Refresh the open product detail price (if a product is open)
            if (curId) {
                const _p = PRODUCTS.find(x => x.id === curId);
                if (_p) {
                    const priceEl = document.getElementById('dPrice');
                    if (priceEl) priceEl.innerHTML = _p.origRaw
                        ? `<span class="sale">${fmtP(_p.priceRaw)}</span><span class="orig">${fmtP(_p.origRaw)}</span>`
                        : `<span class="reg">${fmtP(_p.priceRaw)}</span>`;
                }
            }
        }

        /* ══════════════════════════════════════
           SVG PLACEHOLDERS
        ══════════════════════════════════════ */
        /* ══════════════════════════════════════
           COLOR NAME → HEX LOOKUP
        ══════════════════════════════════════ */
        const COLOR_MAP = {
            // Basics
            black: '#0a0a0a', white: '#f8f8f8', grey: '#888888', gray: '#888888',
            'light grey': '#cccccc', 'light gray': '#cccccc', 'dark grey': '#444444', 'dark gray': '#444444',
            charcoal: '#36454f', silver: '#c0c0c0', off_white: '#f5f5f0', cream: '#fffdd0', ivory: '#fffff0',
            // Reds & Pinks
            red: '#c8241a', 'dark red': '#8b0000', crimson: '#dc143c', maroon: '#800000',
            pink: '#ff69b4', 'light pink': '#ffb6c1', rose: '#ff007f', blush: '#de5d83', salmon: '#fa8072',
            // Oranges
            orange: '#ff6600', 'burnt orange': '#cc5500', rust: '#b7410e', coral: '#ff6b47', peach: '#ffcba4',
            // Yellows
            yellow: '#ffd700', gold: '#cfb53b', mustard: '#ffdb58', tan: '#d2b48c', beige: '#f5f5dc', khaki: '#c3b091',
            // Greens
            green: '#2e7d32', 'dark green': '#005200', 'forest green': '#228b22', olive: '#808000',
            lime: '#32cd32', mint: '#98ff98', sage: '#77815c', army: '#4b5320', hunter: '#355e3b',
            // Blues
            blue: '#1565c0', navy: '#001f5b', 'navy blue': '#001f5b', 'royal blue': '#4169e1',
            'light blue': '#add8e6', sky: '#87ceeb', 'sky blue': '#87ceeb', teal: '#008080',
            cyan: '#00bcd4', cobalt: '#0047ab', denim: '#1560bd', slate: '#708090',
            // Purples
            purple: '#6a1b9a', lavender: '#967bb6', violet: '#7f00ff', plum: '#8e4585',
            magenta: '#ff00ff', burgundy: '#800020', wine: '#722f37', mauve: '#e0b0ff',
            // Browns
            brown: '#795548', 'dark brown': '#36200a', tan2: '#d2b48c', camel: '#c19a6b',
            mocha: '#a0522d', chocolate: '#7b3f00', espresso: '#3b1108', cognac: '#9a4b4b',
            // Neutrals
            nude: '#e3bc9a', taupe: '#8b7d6b', stone: '#928e85', sand: '#c2b280',
            // Metallic
            gold2: '#cfb53b', rose_gold: '#b76e79', copper: '#b87333', bronze: '#cd7f32',
            // Patterns/Mixed (use a representative color)
            camo: '#78866b', camouflage: '#78866b', 'tie dye': '#9b59b6', stripe: '#6c7a89', floral: '#e74c3c',
            grey: '#888888', gray: '#888888',
        };

        function colorToHex(name) {
            if (!name) return '#888888';
            const n = name.toLowerCase().trim().replace(/[-_]/g, ' ');
            // Direct match
            if (COLOR_MAP[n]) return COLOR_MAP[n];
            // Partial match
            for (const [key, val] of Object.entries(COLOR_MAP)) {
                if (n.includes(key) || key.includes(n)) return val;
            }
            // CSS named color fallback — try to render in a temporary canvas
            try {
                const ctx = document.createElement('canvas').getContext('2d');
                ctx.fillStyle = n; // if invalid, stays black
                return ctx.fillStyle !== '#000000' ? ctx.fillStyle : '#888888';
            } catch (e) { return '#888888'; }
        }

        const SVG = {
            tee: (c = '#bbb') => `<svg viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg"><path d="M55 65L20 100l22 18 14-14v86q0 8 10 8h68q10 0 10-8v-86l14 14 22-18L165 65q-15-11-35-15l-10 10q-10 8-20 0L90 50Q70 54 55 65Z" fill="${c}" opacity=".4"/></svg>`,
            chain: (c = '#aaa') => `<svg viewBox="0 0 160 280" xmlns="http://www.w3.org/2000/svg"><g opacity=".5">${Array.from({ length: 8 }, (_, i) => `<ellipse cx="72" cy="${30 + i * 18}" rx="7" ry="4" fill="none" stroke="${c}" stroke-width="3" transform="rotate(${i % 2 ? 15 : 0} 72 ${30 + i * 18})"/><ellipse cx="88" cy="${30 + i * 18}" rx="7" ry="4" fill="none" stroke="${c}" stroke-width="3" transform="rotate(${i % 2 ? -15 : 0} 88 ${30 + i * 18})"/>`).join('')}</g><rect x="72" y="172" width="16" height="56" rx="4" fill="${c}" opacity=".5"/></svg>`,
            slide: (c = '#aaa') => `<svg viewBox="0 0 240 140" xmlns="http://www.w3.org/2000/svg" opacity=".45"><ellipse cx="120" cy="115" rx="100" ry="20" fill="#bbb"/><path d="M25 110Q120 95 215 110v10Q120 108 25 120Z" fill="${c}"/><path d="M55 110Q70 62 100 52h40q30 10 45 58" fill="none" stroke="${c}" stroke-width="28" stroke-linecap="round"/></svg>`,
        };

        /* ══════════════════════════════════════
           PRODUCT DATA
        ══════════════════════════════════════ */
        let PRODUCTS = [], activeFilter = 'all';

        function getCardImgEl(productId) {
            return document.querySelector(`.pcard-img[data-pid="${CSS.escape(productId)}"]`);
        }

        function mapCat(productType, title, categoryName) {
            // Check productType first, then standard categoryName, then fall back to title keywords
            const t = (productType || '').toLowerCase();
            const c = (categoryName || '').toLowerCase();
            const n = (title || '').toLowerCase();
            // Combined string to search: productType + categoryName + title
            const combined = t + ' ' + c + ' ' + n;

            if (combined.match(/hoodie|zip.?up|zipup|sweatshirt|fleece|jacket|long.?sleeve/)) return 'hoodies';
            if (combined.match(/chain|necklace|jewel|pendant|bullet|jewelry|jewellery/)) return 'chains';
            if (combined.match(/slide|slipper|sandal|shoe|footwear/)) return 'slides';
            if (combined.match(/accessor|\bbag\b|\bbags\b|\bhat\b|\bhats\b|beanie|\bcap\b|\bcaps\b|glasses/)) return 'accessories';
            if (combined.match(/short|pant|trouser|jogger|bottom|denim|jean|cargo/)) return 'bottoms';
            // Shirts last so chain/hoodie matches don't bleed through (e.g. "t shirt" in hoodie name)
            if (combined.match(/shirt|tee|t-shirt|t_shirt|tops?\b/)) return 'shirts';
            // If productType was set and we matched nothing, return it as-is
            return t || 'other';
        }

        function parseProduct(node) {
            const fv = node.variants.edges[0]?.node;
            // apiCur = the currency Shopify returned for this fetch (matches cur.code via @inContext).
            // We store it on each product so cards and the detail page always display the correct
            // currency symbol — even if SHOP_CUR (store base currency) differs.
            const apiCur = fv?.price?.currencyCode || cur.code;
            // Only set SHOP_CUR once, on the very first load (no @inContext override yet).
            if (!SHOP_CUR && apiCur) SHOP_CUR = apiCur;
            const priceRaw = parseFloat(fv?.price?.amount || 0);
            const origRaw = fv?.compareAtPrice ? parseFloat(fv.compareAtPrice.amount) : null;
            const szOpt = node.options.find(o => o.name.toLowerCase() === 'size');
            const colOpt = node.options.find(o => ['color', 'colour'].includes(o.name.toLowerCase()));
            const logoColOpt = node.options.find(o => o.name.toLowerCase() === 'logo color');
            const sizes = szOpt ? szOpt.values : ['One Size'];
            const colors = colOpt ? colOpt.values.map(v => ({ name: v, hex: colorToHex(v) })) : [];
            const logoColors = logoColOpt ? logoColOpt.values.map(v => ({ name: v, hex: colorToHex(v) })) : [];
            const unavail = node.variants.edges
                .filter(({ node: v }) => !v.availableForSale)
                .map(({ node: v }) => v.selectedOptions.find(o => o.name.toLowerCase() === 'size')?.value)
                .filter(Boolean);
            const isAvail = node.variants.edges.some(({ node: v }) => v.availableForSale);
            const imgs = node.images.edges.map(e => e.node.url);
            const tagsStr = (node.tags || []).join(' ');

            const variantOptions = [];
            node.variants.edges.forEach(({ node: v }) => {
                const sVal = v.selectedOptions.find(o => o.name.toLowerCase() === 'size')?.value || 'One Size';
                const cVal = v.selectedOptions.find(o => ['color', 'colour'].includes(o.name.toLowerCase()))?.value || null;
                const lVal = v.selectedOptions.find(o => o.name.toLowerCase() === 'logo color')?.value || null;
                variantOptions.push({
                    id: v.id,
                    available: v.availableForSale,
                    price: parseFloat(v.price?.amount || 0),
                    compareAtPrice: v.compareAtPrice ? parseFloat(v.compareAtPrice.amount) : null,
                    image: v.image?.url || null,
                    options: { size: sVal, color: cVal, logoColor: lVal }
                });
            });

            // Build a map of variantId → price so each variant's real price is always available
            const variantPrices = {};
            node.variants.edges.forEach(({ node: v }) => {
                variantPrices[v.id] = parseFloat(v.price?.amount || 0);
            });
            return {
                id: node.id, handle: node.handle, name: node.title,
                desc: node.description || '',
                cat: mapCat(node.productType, node.title + ' ' + tagsStr, node.category?.name),
                priceRaw,
                priceCur: apiCur,   // ← actual currency code returned by Shopify for this product
                origRaw, sizes, colors, logoColors, unavail, isAvail,
                imgs,
                availCount: node.variants.edges.filter(({ node: v }) => v.availableForSale).length,
                variantId: fv?.id,
                variantPrices, // map of variantId → priceRaw in priceCur
                variantOptions,
                tags: node.tags || [],
                productType: node.productType || '',
                categoryName: node.category?.name || '',
            };
        }

        async function loadProducts(country) {
            // IMPORTANT: Shopify's @inContext directive requires a LITERAL enum value, NOT a variable.
            // e.g. @inContext(country:IN) works, but @inContext(country:$country) does NOT.
            // We inline the country code directly into the query string using a template literal.
            const ctry = country || CURRENCY_COUNTRY?.[cur.code] || 'US';
            const Q = `query($c:String) @inContext(country:${ctry}){products(first:50,after:$c){pageInfo{hasNextPage}edges{cursor node{id handle title description productType category{name} tags options{name values}images(first:6){edges{node{url}}}variants(first:250){edges{node{id availableForSale price{amount currencyCode}compareAtPrice{amount currencyCode}image{url}selectedOptions{name value}}}}}}}}`;
            let all = [], cursor = null, more = true;
            while (more) {
                const d = await gql(Q, { c: cursor }); // no 'country' variable — it's inlined above
                if (!d) break;
                const edges = d.products?.edges || [];
                all.push(...edges.map(e => parseProduct(e.node)));
                more = d.products?.pageInfo?.hasNextPage || false;
                cursor = edges.at(-1)?.cursor || null;
            }
            PRODUCTS = all;
            console.log(`Loaded ${PRODUCTS.length} products in ${cur.code} (country: ${ctry})`);
            const catCounts = {};
            PRODUCTS.forEach(p => { catCounts[p.cat] = (catCounts[p.cat] || 0) + 1; });
            console.log('Category distribution:', catCounts);
        }

        /* ══════════════════════════════════════
           RENDER HELPERS
        ══════════════════════════════════════ */
        function visualEl(p, idx = 0) {
            if (p.imgs.length) {
                return `<img src="${p.imgs[Math.min(idx, p.imgs.length - 1)]}" alt="${p.name}" loading="lazy" class="main-img">`;
            }
            const fn = p.cat === 'chains' ? SVG.chain : p.cat === 'slides' ? SVG.slide : SVG.tee;
            return `<span class="main-svg" style="display:flex;align-items:center;justify-content:center;width:100%;height:100%">${fn('#888')}</span>`;
        }

        function visualElRaw(p, idx = 0) {
            if (p.imgs.length) return `<img src="${p.imgs[Math.min(idx, p.imgs.length - 1)]}" alt="${p.name}">`;
            const fn = p.cat === 'chains' ? SVG.chain : p.cat === 'slides' ? SVG.slide : SVG.tee;
            return fn('#888');
        }

        /* ══════════════════════════════════════
           PRODUCT GRID
        ══════════════════════════════════════ */
        const CAT_TITLES = {
            all: 'NEW <span class="r">DROP</span>',
            hoodies: 'HOODIES <span class="r">/ ZIP-UPS</span>',
            shirts: '<span class="r">SHIRTS</span>',
            chains: 'BULLET <span class="r">CHAINS</span>',
            bottoms: 'BOTTOMS <span class="r">&amp; SHORTS</span>',
        };

        function renderGrid(filter = 'all') {
            activeFilter = filter;
            let list = PRODUCTS;
            if (filter === 'all') {
                list = PRODUCTS.filter(p => 
                    p.cat === 'new' || 
                    (p.productType && p.productType.toLowerCase() === 'new') || 
                    (p.categoryName && p.categoryName.toLowerCase() === 'new') || 
                    (p.tags && p.tags.some(t => t.toLowerCase() === 'new'))
                );
                if (!list.length) list = PRODUCTS; // Fallback to all products if no 'new' products are published
            } else {
                list = PRODUCTS.filter(p => p.cat === filter);
            }
            document.getElementById('gridTitle').innerHTML = CAT_TITLES[filter] || CAT_TITLES.all;

            if (!list.length) {
                document.getElementById('grid').innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:100px 0;font-size:8px;letter-spacing:.4em;text-transform:uppercase;color:var(--muted)">${PRODUCTS.length ? 'No products in this category' : 'No products found'}</div>`;
                return;
            }

            // On home page, cap display at 10 products for clean preview
            const displayList = list.slice(0, 10);
            document.getElementById('grid').innerHTML = displayList.map((p, i) => {
                const eid = p.id.replace(/"/g, '&quot;');
                const alt2 = p.imgs[1] ? `<img src="${p.imgs[1]}" class="alt-img" alt="">` : '';
                const colorSwatches = p.colors.length > 1 ? `<div class="pcard-colors" style="display:flex;gap:4px;margin-top:4px;align-items:center">${p.colors.slice(0, 6).map(c => `<span title="${c.name}" style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${c.hex};border:1px solid rgba(0,0,0,.15);flex-shrink:0"></span>`).join('')}${p.colors.length > 6 ? `<span style="font-size:7px;color:var(--muted)">+${p.colors.length - 6}</span>` : ''}</div>` : '';
                const logoColorSwatches = p.logoColors && p.logoColors.length > 0 ? `<div class="pcard-logo-colors" style="display:flex;gap:4px;margin-top:3px;align-items:center"><span style="font-size:6px;letter-spacing:.15em;text-transform:uppercase;color:var(--muted);margin-right:2px">Logo:</span>${p.logoColors.slice(0, 6).map(c => `<span title="${c.name}" style="display:inline-block;width:8px;height:8px;border-radius:2px;background:${c.hex};border:1px solid rgba(0,0,0,.2);flex-shrink:0"></span>`).join('')}</div>` : '';
                return `<div class="pcard" style="animation-delay:${i * .04}s" onclick="openDetail('${eid}',this)">
      <div class="pcard-img" data-pid="${eid}">
        ${p.origRaw ? '<span class="sale-tag">Sale</span>' : ''}
        ${!p.isAvail ? '<div class="sold-veil">Sold Out</div>' : ''}
        <button class="pcard-wish ${wished.has(p.id) ? 'on' : ''}" onclick="event.stopPropagation();toggleWishCard('${eid}',this)">${wished.has(p.id) ? '♥' : '♡'}</button>
        ${visualEl(p, 0)}${alt2}
        ${p.isAvail ? `<button class="pcard-cta" onclick="event.stopPropagation();quickAdd('${eid}')">Add to Bag</button>` : ''}
      </div>
      <div class="pcard-info">
        <div class="pcard-name">${p.name}</div>
        <div class="pcard-price">${p.origRaw
                        ? `<span class="sp">${fmtP(p.priceRaw)}</span><span class="op">${fmtP(p.origRaw)}</span>`
                        : fmtP(p.priceRaw)}</div>
        ${colorSwatches}${logoColorSwatches}
      </div>
    </div>`;
            }).join('');
        }

        function filterCat(cat, el) {
            if (el) { document.querySelectorAll('.nl').forEach(n => n.classList.remove('on')); el.classList.add('on'); }
            renderGrid(cat);
            scrollGrid();
        }
        function scrollGrid() { document.getElementById('gridHead')?.scrollIntoView({ behavior: 'smooth' }); }

        /* ══════════════════════════════════════
           HERO
        ══════════════════════════════════════ */
        let hIdx = 0, hTimer;
        function heroGo(i) {
            hIdx = ((i % 3) + 3) % 3;
            document.getElementById('heroTrack').style.transform = `translateX(-${hIdx * 100}%)`;
            document.querySelectorAll('.pip').forEach((p, j) => p.classList.toggle('on', j === hIdx));
            clearTimeout(hTimer); hTimer = setTimeout(heroNext, 6200);
        }
        function heroNext() { heroGo(hIdx + 1); }
        function heroPrev() { heroGo(hIdx - 1); }
        hTimer = setTimeout(heroNext, 6200);

        /* ══════════════════════════════════════
           SEARCH
        ══════════════════════════════════════ */
        let srchOpen = false;
        function toggleSearch() {
            // Redirect to dedicated search page instead of dropdown
            gotoSearchPage();
        }
        function clearSearch() { document.getElementById('searchInput').value = ''; document.getElementById('searchResults').innerHTML = ''; document.getElementById('searchInput').focus(); }
        let _st;
        function doSearch(v) {
            clearTimeout(_st); if (!v.trim()) { document.getElementById('searchResults').innerHTML = ''; return; }
            _st = setTimeout(() => {
                const q = v.toLowerCase();
                const res = PRODUCTS.filter(p => p.name.toLowerCase().includes(q) || p.desc.toLowerCase().includes(q));
                if (!res.length) { document.getElementById('searchResults').innerHTML = '<div class="s-empty">No results</div>'; return; }
                document.getElementById('searchResults').innerHTML = res.slice(0, 8).map(p => `
      <div class="s-row" onclick="toggleSearch();openDetail('${p.id.replace(/"/g, '&quot;')}')">
        <div class="s-img">${visualEl(p, 0)}</div>
        <div><div class="s-label">${p.name}</div><div class="s-price">${fmtP(p.priceRaw)}</div></div>
      </div>`).join('');
            }, 160);
        }

        /* ══════════════════════════════════════
           PAGES
        ══════════════════════════════════════ */
        function gotoPage(pg) {
            document.querySelectorAll('.page').forEach(el => el.classList.remove('on'));
            document.getElementById('page-' + pg)?.classList.add('on');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            if (pg === 'wishlist') renderWishlist();
        }

        /* ══════════════════════════════════════
           WISHLIST
        ══════════════════════════════════════ */
        let wished = new Set();
        function toggleWishCard(id, btn) {
            if (wished.has(id)) { wished.delete(id); btn.innerHTML = '♡'; btn.classList.remove('on'); toast('Removed from wishlist'); }
            else { wished.add(id); btn.innerHTML = '♥'; btn.classList.add('on'); toast('Added to wishlist ♥'); }
        }
        function toggleWishDetail() {
            if (!curId) return;
            const btn = document.getElementById('dHeart');
            if (wished.has(curId)) { wished.delete(curId); btn.innerHTML = '♡'; btn.classList.remove('on'); toast('Removed from wishlist'); }
            else { wished.add(curId); btn.innerHTML = '♥'; btn.classList.add('on'); toast('Added to wishlist ♥'); }
            const cb = getCardImgEl(curId)?.querySelector('.pcard-wish');
            if (cb) { cb.innerHTML = wished.has(curId) ? '♥' : '♡'; cb.classList.toggle('on', wished.has(curId)); }
        }
        function renderWishlist() {
            const g = document.getElementById('wishGrid'); if (!g) return;
            const items = PRODUCTS.filter(p => wished.has(p.id));
            if (!items.length) { g.innerHTML = `<div style="grid-column:1/-1;padding:40px 0;font-size:8px;letter-spacing:.4em;text-transform:uppercase;color:var(--muted);text-align:center">No items saved</div>`; return; }
            g.innerHTML = items.map(p => {
                const eid = p.id.replace(/"/g, '&quot;');
                return `<div class="pcard" style="opacity:1;transform:none;animation:none" onclick="gotoPage('home');openDetail('${eid}')"><div class="pcard-img" data-pid="${eid}">${visualEl(p, 0)}<button class="pcard-wish on" onclick="event.stopPropagation();toggleWishCard('${eid}',this);renderWishlist()">♥</button></div><div class="pcard-info"><div class="pcard-name">${p.name}</div><div class="pcard-price">${fmtP(p.priceRaw)}</div></div></div>`;
            }).join('');
        }

        /* ══════════════════════════════════════
           MORPH ANIMATION — FIXED & IMPROVED
        ══════════════════════════════════════ */
        let curId = null, dSlideIdx = 0, selSw = 0, selLogoSw = 0, selSz = null, detQty = 1, morphRect = null;
        const morph = document.getElementById('morph');

        function morphReset() {
            morph.classList.remove('expanding', 'collapsing');
            morph.style.cssText = 'top:0;left:0;width:0;height:0;opacity:0;';
        }

        function openDetail(id, cardEl) {
            if (curId !== id) {
                trackView(id);
            }
            const p = PRODUCTS.find(x => x.id === id); if (!p) return;
            curId = id; dSlideIdx = 0; selSw = 0; selLogoSw = 0; detQty = 1;
            const defaultColor = p.colors.length > 0 ? p.colors[0].name : null;
            const defaultLogoColor = p.logoColors.length > 0 ? p.logoColors[0].name : null;
            selSz = p.sizes.find(sz => {
                return p.variantOptions.some(v => {
                    return v.options.size === sz &&
                           (!defaultColor || v.options.color === defaultColor) &&
                           (!defaultLogoColor || v.options.logoColor === defaultLogoColor) &&
                           v.available;
                });
            }) || p.sizes.find(s => !p.unavail.includes(s)) || p.sizes[0] || null;

            const imgEl = getCardImgEl(id);
            const rect = imgEl ? imgEl.getBoundingClientRect() : { top: window.innerHeight / 2, left: window.innerWidth / 2, width: 0, height: 0 };
            morphRect = rect;

            morph.classList.remove('expanding', 'collapsing');
            morph.innerHTML = visualElRaw(p, 0);
            morph.style.cssText = `top:${rect.top}px;left:${rect.left}px;width:${rect.width}px;height:${rect.height}px;opacity:1;`;

            morph.getBoundingClientRect(); // reflow
            morph.classList.add('expanding');
            morph.style.top = '0'; morph.style.left = '0';
            morph.style.width = '100%'; morph.style.height = '100vh';

            setTimeout(() => {
                populateDetail(p);
                renderSimilar();
                document.getElementById('detail').classList.add('on');
                document.body.style.overflow = 'hidden';
                morph.style.opacity = '0';
                setTimeout(() => morphReset(), 240);
            }, 580);
        }

        function populateDetail(p) {
            const track = document.getElementById('dtrack');
            const thumbs = document.getElementById('dthumbs');
            const slides = p.imgs.length ? p.imgs : [''];
            const cnt = slides.length;

            track.innerHTML = slides.map((url, i) => `
    <div class="dimg-slide" style="animation:fadeScale .4s ease ${i === 0 ? .04 : 0}s both">
      ${url ? `<img src="${url}" alt="${p.name}">` : (() => { const fn = p.cat === 'chains' ? SVG.chain : p.cat === 'slides' ? SVG.slide : SVG.tee; return fn('#888'); })()}
    </div>`).join('');
            track.style.transform = 'translateX(0)';

            thumbs.innerHTML = cnt > 1 ? slides.map((url, i) => `
    <div class="dthumb ${i === 0 ? 'on' : ''}" onclick="dGoSlide(${i})">
      ${url ? `<img src="${url}">` : ''}
    </div>`).join('') : '';

            document.getElementById('dName').textContent = p.name;
            document.getElementById('dPrice').innerHTML = p.origRaw
                ? `<span class="sale">${fmtP(p.priceRaw)}</span><span class="orig">${fmtP(p.origRaw)}</span>`
                : `<span class="reg">${fmtP(p.priceRaw)}</span>`;

            const st = document.getElementById('dStock');
            if (!p.isAvail) { st.textContent = 'Sold out'; st.className = 'd-stock out'; }
            else if (p.availCount <= 3) { st.textContent = `Only ${p.availCount} left`; st.className = 'd-stock low'; }
            else { st.textContent = 'In stock'; st.className = 'd-stock in'; }

            document.getElementById('dDesc').textContent = p.desc || 'No description available.';
            document.getElementById('qval').textContent = '1';

            const show = (id, v) => { const el = document.getElementById(id); if (el) el.style.display = v; };

            if (p.colors.length > 1) {
                show('dColLbl', 'block'); show('dSwatches', 'flex'); show('dSwName', 'block');
                document.getElementById('dSwatches').innerHTML = p.colors.map((c, i) =>
                    `<button class="d-swatch ${i === 0 ? 'on' : ''}" style="background:${c.hex}" title="${c.name}" onclick="selColor(${i},'${c.name}')"></button>`
                ).join('');
                document.getElementById('dSwName').textContent = p.colors[0].name;
            } else { show('dColLbl', 'none'); show('dSwatches', 'none'); show('dSwName', 'none'); }

            if (p.logoColors && p.logoColors.length > 0) {
                show('dLColLbl', 'block'); show('dLSwatches', 'flex'); show('dLSwName', 'block');
                document.getElementById('dLSwatches').innerHTML = p.logoColors.map((c, i) =>
                    `<button class="d-swatch ${i === 0 ? 'on' : ''}" style="background:${c.hex}" title="${c.name}" onclick="selLogoColor(${i},'${c.name}')"></button>`
                ).join('');
                document.getElementById('dLSwName').textContent = p.logoColors[0].name;
            } else { show('dLColLbl', 'none'); show('dLSwatches', 'none'); show('dLSwName', 'none'); }

            if (p.sizes.length && !(p.sizes.length === 1 && p.sizes[0] === 'One Size')) {
                show('dSzLbl', 'block'); show('dSizes', 'flex'); show('dSzGuide', 'inline-block');
                document.getElementById('dSizes').innerHTML = p.sizes.map(s =>
                    `<button class="d-sz ${s === selSz ? 'on' : ''}" onclick="selSize(this)">${s}</button>`
                ).join('');
            } else { show('dSzLbl', 'none'); show('dSizes', 'none'); show('dSzGuide', 'none'); }

            const ab = document.getElementById('dAddBtn');
            ab.textContent = p.isAvail ? 'Add to Bag' : 'Sold Out';
            ab.disabled = !p.isAvail; ab.classList.remove('added');

            const dh = document.getElementById('dHeart');
            dh.innerHTML = wished.has(curId) ? '♥' : '♡';
            dh.classList.toggle('on', wished.has(curId));

            updateDetailInteractiveState();
        }

        /* ══════════════════════════════════════
           RECENTLY VIEWED
        ══════════════════════════════════════ */
        function trackView(productId) {
            let seen = JSON.parse(localStorage.getItem('nwio_recent') || '[]');
            seen = [productId, ...seen.filter(id => id !== productId)].slice(0, 8);
            localStorage.setItem('nwio_recent', JSON.stringify(seen));
            renderRecentHome();
        }

        function renderSimilar() {
            const g = document.getElementById('similarGrid');
            const sec = document.getElementById('similarSection');
            if (!g || !sec || !curId) return;

            const curP = PRODUCTS.find(p => p.id === curId);
            if (!curP) { sec.style.display = 'none'; return; }

            // Get products in the same category, excluding the current product
            const items = PRODUCTS.filter(p => p.cat === curP.cat && p.id !== curId).slice(0, 4);

            if (!items.length) {
                sec.style.display = 'none';
                return;
            }

            sec.style.display = 'block';
            g.innerHTML = items.map((p, i) => {
                const eid = p.id.replace(/"/g, '&quot;');
                return `<div class="pcard" style="animation-delay:${i * .05}s" onclick="openDetail('${eid}'); document.getElementById('detail').scrollTo({top:0,behavior:'smooth'})">
      <div class="pcard-img" data-pid="${eid}">
        ${p.origRaw ? '<span class="sale-tag">Sale</span>' : ''}
        ${!p.isAvail ? '<div class="sold-veil">Sold Out</div>' : ''}
        ${visualEl(p, 0)}
      </div>
      <div class="pcard-info">
        <div class="pcard-name">${p.name}</div>
        <div class="pcard-price">${p.origRaw ? `<span class="sp">${fmtP(p.priceRaw)}</span><span class="op">${fmtP(p.origRaw)}</span>` : fmtP(p.priceRaw)}</div>
      </div>
    </div>`;
            }).join('');
        }

        function renderRecentHome() {
            const g = document.getElementById('homeRecentGrid');
            const sec = document.getElementById('homeRecentSection');
            if (!g || !sec) return;

            const seen = JSON.parse(localStorage.getItem('nwio_recent') || '[]');
            const items = seen.map(id => PRODUCTS.find(p => p.id === id)).filter(Boolean);

            if (!items.length) {
                sec.style.display = 'none';
                return;
            }

            sec.style.display = 'block';
            g.innerHTML = items.map((p, i) => {
                const eid = p.id.replace(/"/g, '&quot;');
                const alt2 = p.imgs[1] ? `<img src="${p.imgs[1]}" class="alt-img" alt="">` : '';
                return `<div class="pcard" style="animation-delay:${i * .03}s" onclick="openDetail('${eid}'); window.scrollTo({top:0, behavior:'smooth'})">
      <div class="pcard-img" data-pid="${eid}">
        ${p.origRaw ? '<span class="sale-tag">Sale</span>' : ''}
        ${!p.isAvail ? '<div class="sold-veil">Sold Out</div>' : ''}
        <button class="pcard-wish ${wished.has(p.id) ? 'on' : ''}" onclick="event.stopPropagation();toggleWishCard('${eid}',this)">${wished.has(p.id) ? '♥' : '♡'}</button>
        ${visualEl(p, 0)}${alt2}
        ${p.isAvail ? `<button class="pcard-cta" onclick="event.stopPropagation();quickAdd('${eid}')">Add to Bag</button>` : ''}
      </div>
      <div class="pcard-info">
        <div class="pcard-name">${p.name}</div>
        <div class="pcard-price">${p.origRaw ? `<span class="sp">${fmtP(p.priceRaw)}</span><span class="op">${fmtP(p.origRaw)}</span>` : fmtP(p.priceRaw)}</div>
      </div>
    </div>`;
            }).join('');
        }

        function closeDetail() {
            const p = PRODUCTS.find(x => x.id === curId);
            morph.classList.remove('expanding', 'collapsing');
            morph.innerHTML = p ? visualElRaw(p, dSlideIdx) : '';
            morph.style.cssText = 'top:0;left:0;width:100%;height:100vh;opacity:1;';

            document.getElementById('detail').classList.remove('on');
            document.body.style.overflow = '';

            morph.getBoundingClientRect();
            morph.classList.add('collapsing');

            const imgEl = getCardImgEl(curId);
            const tgt = (imgEl ? imgEl.getBoundingClientRect() : null) || morphRect || { top: window.innerHeight / 2, left: window.innerWidth / 2, width: 0, height: 0 };
            if (imgEl) morphRect = tgt;

            morph.style.top = `${tgt.top}px`;
            morph.style.left = `${tgt.left}px`;
            morph.style.width = `${tgt.width}px`;
            morph.style.height = `${tgt.height}px`;

            setTimeout(() => morphReset(), 820);
        }

        function dGoSlide(idx) {
            const p = PRODUCTS.find(x => x.id === curId); if (!p) return;
            const cnt = Math.max(p.imgs.length, 1);
            dSlideIdx = ((idx % cnt) + cnt) % cnt;
            document.getElementById('dtrack').style.transform = `translateX(-${dSlideIdx * 100}%)`;
            document.querySelectorAll('.dthumb').forEach((t, i) => t.classList.toggle('on', i === dSlideIdx));
        }
        function dSlide(dir) { dGoSlide(dSlideIdx + dir); }
        function selColor(i, name) {
            selSw = i;
            document.querySelectorAll('#dSwatches .d-swatch').forEach((s, j) => s.classList.toggle('on', j === i));
            document.getElementById('dSwName').textContent = name;
            updateDetailInteractiveState(true);
        }
        function selLogoColor(i, name) {
            selLogoSw = i;
            document.querySelectorAll('#dLSwatches .d-swatch').forEach((s, j) => s.classList.toggle('on', j === i));
            document.getElementById('dLSwName').textContent = name;
            updateDetailInteractiveState(true);
        }
        function selSize(btn) {
            if (btn.classList.contains('na')) return;
            const sz = btn.textContent;
            selSz = sz;
            document.querySelectorAll('.d-sz').forEach(b => b.classList.toggle('on', b === btn));
            updateDetailInteractiveState();
        }
        function updateDetailInteractiveState(checkSizeSwap = false) {
            const p = PRODUCTS.find(x => x.id === curId);
            if (!p) return;

            const selectedColor = p.colors.length > 0 ? p.colors[selSw]?.name : null;
            const selectedLogoColor = p.logoColors.length > 0 ? p.logoColors[selLogoSw]?.name : null;

            if (checkSizeSwap && selSz) {
                const isCurrentSizeAvail = p.variantOptions.some(v => {
                    return v.options.size === selSz &&
                           (!selectedColor || v.options.color === selectedColor) &&
                           (!selectedLogoColor || v.options.logoColor === selectedLogoColor) &&
                           v.available;
                });
                if (!isCurrentSizeAvail) {
                    const firstAvailSz = p.sizes.find(sz => {
                        return p.variantOptions.some(v => {
                            return v.options.size === sz &&
                                   (!selectedColor || v.options.color === selectedColor) &&
                                   (!selectedLogoColor || v.options.logoColor === selectedLogoColor) &&
                                   v.available;
                        });
                    });
                    if (firstAvailSz) {
                        selSz = firstAvailSz;
                    }
                }
            }

            if (p.sizes.length && !(p.sizes.length === 1 && p.sizes[0] === 'One Size')) {
                const sizeButtons = document.querySelectorAll('#dSizes .d-sz');
                sizeButtons.forEach(btn => {
                    const sz = btn.textContent;
                    const isVariantAvail = p.variantOptions.some(v => {
                        return v.options.size === sz &&
                               (!selectedColor || v.options.color === selectedColor) &&
                               (!selectedLogoColor || v.options.logoColor === selectedLogoColor) &&
                               v.available;
                    });
                    btn.classList.toggle('na', !isVariantAvail);
                    btn.classList.toggle('on', sz === selSz);
                });
            }

            const activeVariant = p.variantOptions.find(v => {
                const matchSize = !selSz || v.options.size === selSz;
                const matchColor = !selectedColor || v.options.color === selectedColor;
                const matchLogo = !selectedLogoColor || v.options.logoColor === selectedLogoColor;
                return matchSize && matchColor && matchLogo;
            });

            const priceEl = document.getElementById('dPrice');
            if (priceEl) {
                if (activeVariant) {
                    const price = activeVariant.price;
                    const comparePrice = activeVariant.compareAtPrice;
                    priceEl.innerHTML = comparePrice
                        ? `<span class="sale">${fmtP(price)}</span><span class="orig">${fmtP(comparePrice)}</span>`
                        : `<span class="reg">${fmtP(price)}</span>`;
                } else {
                    priceEl.innerHTML = p.origRaw
                        ? `<span class="sale">${fmtP(p.priceRaw)}</span><span class="orig">${fmtP(p.origRaw)}</span>`
                        : `<span class="reg">${fmtP(p.priceRaw)}</span>`;
                }
            }

            const st = document.getElementById('dStock');
            if (st) {
                if (activeVariant) {
                    if (!activeVariant.available) {
                        st.textContent = 'Sold out';
                        st.className = 'd-stock out';
                    } else {
                        st.textContent = 'In stock';
                        st.className = 'd-stock in';
                    }
                } else {
                    if (!p.isAvail) {
                        st.textContent = 'Sold out';
                        st.className = 'd-stock out';
                    } else {
                        st.textContent = 'In stock';
                        st.className = 'd-stock in';
                    }
                }
            }

            const ab = document.getElementById('dAddBtn');
            if (ab) {
                const canAdd = activeVariant ? activeVariant.available : p.isAvail;
                ab.textContent = canAdd ? 'Add to Bag' : 'Sold Out';
                ab.disabled = !canAdd;
            }

            if (activeVariant && activeVariant.image) {
                const imgIdx = p.imgs.indexOf(activeVariant.image);
                if (imgIdx !== -1) {
                    dGoSlide(imgIdx);
                }
            } else if (selectedColor) {
                const firstColorVar = p.variantOptions.find(v => v.options.color === selectedColor && v.image);
                if (firstColorVar) {
                    const imgIdx = p.imgs.indexOf(firstColorVar.image);
                    if (imgIdx !== -1) {
                        dGoSlide(imgIdx);
                    }
                }
            }
        }
        function adjQty(d) { detQty = Math.max(1, Math.min(10, detQty + d)); document.getElementById('qval').textContent = detQty; }
        function acToggle(hd) { hd.parentElement.classList.toggle('open') }

        document.addEventListener('keydown', e => {
            if (!document.getElementById('detail').classList.contains('on')) return;
            if (e.key === 'ArrowLeft') dSlide(-1);
            if (e.key === 'ArrowRight') dSlide(1);
            if (e.key === 'Escape') closeDetail();
        });
        let _tx = 0;
        document.getElementById('detail').addEventListener('touchstart', e => { _tx = e.touches[0].clientX; }, { passive: true });
        document.getElementById('detail').addEventListener('touchend', e => { if (Math.abs(e.changedTouches[0].clientX - _tx) > 48) dSlide(e.changedTouches[0].clientX > _tx ? -1 : 1); });

        /* ══════════════════════════════════════
           SHOPIFY CART
        ══════════════════════════════════════ */
        let cartId = null, checkoutUrl = null, cartLines = [];
        function getVariantId(p, size, color, logoColor) {
            const matched = p.variantOptions.find(v => {
                const matchSize = !size || v.options.size === size;
                const matchColor = !color || !v.options.color || v.options.color.toLowerCase() === color.toLowerCase();
                const matchLogo = !logoColor || !v.options.logoColor || v.options.logoColor.toLowerCase() === logoColor.toLowerCase();
                return matchSize && matchColor && matchLogo;
            });
            return matched ? matched.id : p.variantId;
        }
        async function addToCart(id, color, size, logoColor, qty = 1) {
            const p = PRODUCTS.find(x => x.id === id); if (!p) return;
            await ensureCart();
            const vid = getVariantId(p, size, color, logoColor);
            const d = await gql(`mutation add($cId:ID!,$lines:[CartLineInput!]!){cartLinesAdd(cartId:$cId,lines:$lines){cart{checkoutUrl lines(first:30){edges{node{id quantity merchandise{...on ProductVariant{id price{amount currencyCode}product{title}selectedOptions{name value}}}}}}}userErrors{field message}}}`,
                { cId: cartId, lines: [{ merchandiseId: vid, quantity: qty }] });
            if (d?.cartLinesAdd?.userErrors?.length) { toast('Could not add item'); return; }
            if (d?.cartLinesAdd?.cart) { checkoutUrl = d.cartLinesAdd.cart.checkoutUrl; syncLines(d.cartLinesAdd.cart, p, color, size, logoColor); toastCart('Added to bag ✦'); }
        }
        async function removeFromCart(lid) {
            if (!cartId) return;
            const d = await gql(`mutation rm($cId:ID!,$lids:[ID!]!){cartLinesRemove(cartId:$cId,lineIds:$lids){cart{checkoutUrl lines(first:30){edges{node{id quantity merchandise{...on ProductVariant{id price{amount currencyCode}product{title}selectedOptions{name value}}}}}}}}}`,
                { cId: cartId, lids: [lid] });
            if (d?.cartLinesRemove?.cart) { checkoutUrl = d.cartLinesRemove.cart.checkoutUrl; cartLines = cartLines.filter(l => l.id !== lid); renderCartUI(); }
        }
        async function updateCartQty(lid, qty) {
            if (!cartId || qty < 1) { removeFromCart(lid); return; }
            const d = await gql(`mutation u($cId:ID!,$lines:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$cId,lines:$lines){cart{checkoutUrl lines(first:30){edges{node{id quantity merchandise{...on ProductVariant{id price{amount currencyCode}product{title}selectedOptions{name value}}}}}}}}}`,
                { cId: cartId, lines: [{ id: lid, quantity: qty }] });
            if (d?.cartLinesUpdate?.cart) {
                checkoutUrl = d.cartLinesUpdate.cart.checkoutUrl;
                syncLines(d.cartLinesUpdate.cart, null, null, null, null);
            }
        }
        function syncLines(cart, addedP, color, size, logoColor) {
            cartLines = cart.lines.edges.map(({ node }) => {
                const ex = cartLines.find(l => l.id === node.id);
                const priceRaw = parseFloat(node.merchandise.price.amount);
                const currencyCode = node.merchandise.price.currencyCode || cur.code;
                return {
                    id: node.id,
                    name: node.merchandise.product.title,
                    priceRaw,
                    currencyCode,
                    qty: node.quantity,
                    color: color || ex?.color || node.merchandise.selectedOptions.find(o => ['colour', 'color'].includes(o.name.toLowerCase()))?.value || null,
                    logoColor: logoColor || ex?.logoColor || node.merchandise.selectedOptions.find(o => o.name.toLowerCase() === 'logo color')?.value || null,
                    size: size || ex?.size || node.merchandise.selectedOptions.find(o => o.name.toLowerCase() === 'size')?.value || null,
                    imgs: ex?.imgs ?? addedP?.imgs ?? [],
                    cat: ex?.cat ?? addedP?.cat ?? 'other',
                    variantId: node.merchandise.id,
                };
            });
            renderCartUI();
        }
        function cartThumb(item) {
            if (item.imgs?.length) return `<img src="${item.imgs[0]}" style="width:100%;height:100%;object-fit:cover">`;
            const fn = item.cat === 'chains' ? SVG.chain : item.cat === 'slides' ? SVG.slide : SVG.tee;
            return fn('#aaa');
        }
        function renderCartUI() {
            const badge = document.getElementById('cbadge');
            const body = document.getElementById('cartBody');
            const foot = document.getElementById('cartFoot');
            const total = cartLines.reduce((a, i) => a + (i.qty || 1), 0);
            badge.textContent = total; badge.classList.toggle('on', total > 0);
            document.getElementById('cartCount').textContent = total;

            if (!cartLines.length) {
                body.innerHTML = '<div class="cart-empty-msg"><span>Your bag is empty</span><button class="empty-cta" onclick="toggleCart()">Continue Shopping</button></div>';
                foot.style.display = 'none'; return;
            }
            body.innerHTML = cartLines.map(item => `
    <div class="citem">
      <div class="cthumb">${cartThumb(item)}</div>
      <div style="flex:1;padding-right:20px">
        <div class="cname">${item.name}</div>
        ${item.color || item.logoColor || item.size ? `<div class="cmeta">${[item.color, item.logoColor ? `Logo: ${item.logoColor}` : null, item.size].filter(Boolean).join(' · ')}</div>` : ''}
        <div class="cprice">${fmtP(item.priceRaw * (item.qty || 1))}</div>
        <div class="cqty">
          <button class="cq-btn" onclick="updateCartQty('${item.id}',${(item.qty || 1) - 1})">−</button>
          <span class="cq-n">${item.qty || 1}</span>
          <button class="cq-btn" onclick="updateCartQty('${item.id}',${(item.qty || 1) + 1})">+</button>
        </div>
      </div>
      <button class="crm" onclick="removeFromCart('${item.id}')">×</button>
    </div>`).join('');

            const sub = cartLines.reduce((a, i) => a + i.priceRaw * (i.qty || 1), 0);
            // sub is in the cart's checkout currency (= cur.code, set via @inContext at cart creation).
            // fmtP formats it directly with the current display symbol — no conversion needed.
            document.getElementById('cSub').textContent = fmtP(sub);
            document.getElementById('cTot').textContent = fmtP(sub);
            document.getElementById('cTotBtn').textContent = 'Checkout · ' + fmtP(sub);
            foot.style.display = 'block';
        }
        /* goCheckout replaced by currency-aware version */
        async function addFromDetail() {
            const p = PRODUCTS.find(x => x.id === curId); if (!p) return;
            const btn = document.getElementById('dAddBtn');
            btn.disabled = true; btn.innerHTML = '<span class="spin"></span>Adding…';
            await addToCart(curId, p.colors[selSw]?.name || null, selSz, p.logoColors[selLogoSw]?.name || null, detQty);
            btn.innerHTML = '✓ Added'; btn.classList.add('added');
            setTimeout(() => { btn.textContent = 'Add to Bag'; btn.classList.remove('added'); btn.disabled = false; }, 2400);
        }
        async function quickAdd(id) {
            const p = PRODUCTS.find(x => x.id === id); if (!p) return;
            const availVar = p.variantOptions.find(v => v.available) || p.variantOptions[0];
            await addToCart(id, availVar?.options.color || null, availVar?.options.size || null, availVar?.options.logoColor || null, 1);
        }

        /* ══════════════════════════════════════
           UI HELPERS
        ══════════════════════════════════════ */
        function toggleCart() { document.getElementById('cartPanel').classList.toggle('on'); document.getElementById('cartBg').classList.toggle('on'); }
        function toggleMob() { document.getElementById('mobMenu').classList.toggle('on'); }
        function openSzModal() { document.getElementById('szModal').classList.add('on'); }
        function closeSzModal() { document.getElementById('szModal').classList.remove('on'); }
        function faqToggle(el) {
            const item = el.parentElement, was = item.classList.contains('open');
            document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
            if (!was) item.classList.add('open');
        }
        function submitContact() {
            const n = document.getElementById('cName').value.trim(), e = document.getElementById('cEmail').value.trim(), m = document.getElementById('cMsg').value.trim();
            if (!n || !e || !m) { toast('Please fill all required fields'); return; }
            toast("Message sent — we'll be in touch.");
            ['cName', 'cEmail', 'cOrder', 'cMsg'].forEach(id => { const el = document.getElementById(id); if (el) el.value = ''; });
        }
        function subNL() {
            const el = document.getElementById('nlEmail');
            if (!el.value.includes('@')) { toast('Enter a valid email'); return; }
            toast('Subscribed ✦'); el.value = '';
        }
        let _tt;
        function toast(msg) {
            const msgEl = document.getElementById('toastMsg');
            const btnEl = document.getElementById('toastBtn');
            if (msgEl) { msgEl.textContent = msg; } else { document.getElementById('toast').textContent = msg; }
            if (btnEl) btnEl.style.display = 'none'; // hide cart button for plain toasts
            document.getElementById('toast').classList.add('show');
            clearTimeout(_tt); _tt = setTimeout(() => document.getElementById('toast').classList.remove('show'), 2500);
        }
        function toastCart(msg) {
            // Rich toast with "View Cart" action button
            const msgEl = document.getElementById('toastMsg');
            const btnEl = document.getElementById('toastBtn');
            if (msgEl) msgEl.textContent = msg;
            if (btnEl) btnEl.style.display = 'inline-block';
            document.getElementById('toast').classList.add('show');
            clearTimeout(_tt); _tt = setTimeout(() => {
                document.getElementById('toast').classList.remove('show');
                if (btnEl) setTimeout(() => { btnEl.style.display = 'none'; }, 400);
            }, 4000); // longer display so user can click View Cart
        }

        /* ── Hamburger: show only on mobile ── */
        function updateHamburger() {
            const h = document.getElementById('hamburger');
            const nl = document.getElementById('navLinks');
            if (window.innerWidth <= 900) { h.style.display = 'flex'; nl.style.display = 'none'; }
            else { h.style.display = 'none'; nl.style.display = 'flex'; }
        }
        window.addEventListener('resize', updateHamburger);
        updateHamburger();

        /* ── Animate announcement bar width ── */
        (function () {
            const inner = document.getElementById('annInner');
            if (!inner) return;
            const w = inner.scrollWidth / 2;
            inner.style.animation = `ticker ${w / 40}s linear infinite`;
        })();

        /* ══════════════════════════════════════
           INIT
        ══════════════════════════════════════ */
        (async () => {
            // Skeleton grid
            document.getElementById('grid').innerHTML = Array(10).fill(0).map((_, i) =>
                `<div class="skel-card" style="animation-delay:${i * .08}s"></div>`
            ).join('');

            await Promise.all([loadRates(), loadProducts()]);

            if (!PRODUCTS.length) {
                // Diagnose the failure so the owner can see what's wrong
                const diagMsg = `Could not load products from ${DOMAIN}.\n\nPossible causes:\n` +
                    `1. DOMAIN or TOKEN is still the placeholder value\n` +
                    `2. The Storefront Access Token doesn't have "unauthenticated_read_product_listings" permission\n` +
                    `3. The store has no published products\n\nSee the browser console (F12) for the exact error.`;
                console.warn('⚠ PRODUCTS empty after load. ' + diagMsg);
                document.getElementById('grid').innerHTML =
                    `<div style="grid-column:1/-1;text-align:center;padding:60px 20px;font-size:8px;letter-spacing:.3em;` +
                    `text-transform:uppercase;color:var(--muted);line-height:2.2;max-width:520px;margin:0 auto">` +
                    `No products found<br><span style="letter-spacing:.1em;text-transform:none;font-size:9px;color:#c8241a">` +
                    `Check DOMAIN &amp; TOKEN in the &lt;script&gt; config, then open F12 Console for details` +
                    `</span></div>`;
                return;
            }

            console.log(`Store cur: ${SHOP_CUR}. Display: ${cur.label}`);
            renderGrid('all');
            renderRecentHome();
            // Pre-render search page with all products
            if (typeof doPageSearch === 'function') doPageSearch('');
        })();

        /* ══════════════════════════════════════
           COLLECTION PAGE LOGIC
        ══════════════════════════════════════ */
        const CAT_LABELS = {
            all: 'All Products', hoodies: 'Hoodies / Zip-Ups',
            shirts: 'Shirts', chains: 'Chains', bottoms: 'Bottoms'
        };

        let colCatFilter = 'all';
        let searchCatFilter = 'all';
        let searchQuery = '';

        function gotoCollection(cat) {
            // Update nav active state
            document.querySelectorAll('.nl').forEach(n => n.classList.remove('on'));
            document.querySelectorAll('.nl').forEach(n => {
                const txt = n.textContent.trim().toLowerCase();
                if (cat === 'all' && txt.startsWith('all')) n.classList.add('on');
                else if (cat === 'hoodies' && (txt.startsWith('hood') || txt.includes('hoodie'))) n.classList.add('on');
                else if (cat === 'shirts' && txt.startsWith('shirt')) n.classList.add('on');
                else if (cat === 'chains' && txt.startsWith('chain')) n.classList.add('on');
                else if (cat === 'bottoms' && txt.startsWith('bottom')) n.classList.add('on');
            });

            // Set the category radio in sidebar
            colCatFilter = cat;
            document.querySelectorAll('input[name="fcat"]').forEach(r => {
                r.checked = (r.value === cat);
            });

            // Update page header
            const label = CAT_LABELS[cat] || 'Products';
            document.getElementById('colTitle').textContent = label.toUpperCase();
            document.getElementById('colBreadcrumb').textContent = label;

            // Show collection page
            gotoPage('collection');
            applyFilters();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        function applyFilters() {
            // Read all filter states
            const cat = document.querySelector('input[name="fcat"]:checked')?.value || 'all';
            colCatFilter = cat;
            const inStock = document.getElementById('fInStock')?.checked || false;
            const price = document.querySelector('input[name="fprice"]:checked')?.value || 'all';
            const checkedSizes = [...document.querySelectorAll('#fSizes input:checked')].map(i => i.value);
            const sort = document.getElementById('colSortDesktop')?.value || document.getElementById('colSort')?.value || 'featured';

            // Update breadcrumb / title
            const label = CAT_LABELS[cat] || 'Products';
            document.getElementById('colTitle').textContent = label.toUpperCase();
            document.getElementById('colBreadcrumb').textContent = label;

            // Filter products
            let list = [...PRODUCTS];
            if (cat !== 'all') list = list.filter(p => p.cat === cat);
            if (inStock) list = list.filter(p => p.isAvail);
            if (price !== 'all') {
                const [mn, mx] = price.split('-');
                list = list.filter(p => {
                    const usd = p.priceRaw / (RATES[SHOP_CUR] || 1);
                    if (mx) return usd >= +mn && usd <= +mx;
                    return usd >= 100;
                });
            }
            if (checkedSizes.length) {
                list = list.filter(p => checkedSizes.some(sz => p.sizes.includes(sz) && !p.unavail.includes(sz)));
            }

            // Sort
            if (sort === 'price-asc') list.sort((a, b) => a.priceRaw - b.priceRaw);
            if (sort === 'price-desc') list.sort((a, b) => b.priceRaw - a.priceRaw);
            if (sort === 'alpha') list.sort((a, b) => a.name.localeCompare(b.name));

            // Render
            renderColGrid(list);

            // Update count
            const rc = document.getElementById('colResultCount');
            if (rc) rc.textContent = list.length + (list.length === 1 ? ' product' : ' products');
            const cm = document.getElementById('colMeta');
            if (cm) cm.textContent = list.length + (list.length === 1 ? ' product' : ' products');

            // Active filter tags
            renderFilterTags(cat, inStock, price, checkedSizes);

            // Filter count badge
            let cnt = 0;
            if (cat !== 'all') cnt++;
            if (inStock) cnt++;
            if (price !== 'all') cnt++;
            cnt += checkedSizes.length;
            const fc = document.getElementById('filterCount');
            if (fc) { fc.textContent = cnt; fc.style.display = cnt ? 'inline-flex' : 'none'; }
        }

        function renderColGrid(list) {
            const grid = document.getElementById('colGrid');
            if (!grid) return;
            if (!list.length) {
                grid.innerHTML = '<div class="col-empty">No products match your filters</div>';
                return;
            }
            grid.innerHTML = list.map((p, i) => {
                const eid = p.id.replace(/"/g, '&quot;');
                const alt2 = p.imgs[1] ? `<img src="${p.imgs[1]}" class="alt-img" alt="">` : '';
                const colorSwatches = p.colors.length > 1 ? `<div class="pcard-colors" style="display:flex;gap:4px;margin-top:4px;align-items:center">${p.colors.slice(0, 6).map(c => `<span title="${c.name}" style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${c.hex};border:1px solid rgba(0,0,0,.15);flex-shrink:0"></span>`).join('')}${p.colors.length > 6 ? `<span style="font-size:7px;color:var(--muted)">+${p.colors.length - 6}</span>` : ''}</div>` : '';
                const logoColorSwatches = p.logoColors && p.logoColors.length > 0 ? `<div class="pcard-logo-colors" style="display:flex;gap:4px;margin-top:3px;align-items:center"><span style="font-size:6px;letter-spacing:.15em;text-transform:uppercase;color:var(--muted);margin-right:2px">Logo:</span>${p.logoColors.slice(0, 6).map(c => `<span title="${c.name}" style="display:inline-block;width:8px;height:8px;border-radius:2px;background:${c.hex};border:1px solid rgba(0,0,0,.2);flex-shrink:0"></span>`).join('')}</div>` : '';
                return `<div class="pcard" style="animation-delay:${i * .03}s" onclick="openDetail('${eid}',this)">
      <div class="pcard-img" data-pid="${eid}">
        ${p.origRaw ? '<span class="sale-tag">Sale</span>' : ''}
        ${!p.isAvail ? '<div class="sold-veil">Sold Out</div>' : ''}
        <button class="pcard-wish ${wished.has(p.id) ? 'on' : ''}" onclick="event.stopPropagation();toggleWishCard('${eid}',this)">${wished.has(p.id) ? '♥' : '♡'}</button>
        ${visualEl(p, 0)}${alt2}
        ${p.isAvail ? `<button class="pcard-cta" onclick="event.stopPropagation();quickAdd('${eid}')">Add to Bag</button>` : ''}
      </div>
      <div class="pcard-info">
        <div class="pcard-name">${p.name}</div>
        <div class="pcard-price">${p.origRaw ? `<span class="sp">${fmtP(p.priceRaw)}</span><span class="op">${fmtP(p.origRaw)}</span>` : fmtP(p.priceRaw)}</div>
        ${colorSwatches}${logoColorSwatches}
      </div>
    </div>`;
            }).join('');
        }

        function renderFilterTags(cat, inStock, price, sizes) {
            const existing = document.querySelector('.active-filters');
            if (existing) existing.remove();
            const tags = [];
            if (cat !== 'all') tags.push({ label: CAT_LABELS[cat], clear: () => { document.querySelector('input[name="fcat"][value="all"]').checked = true; applyFilters(); } });
            if (inStock) tags.push({ label: 'In Stock', clear: () => { document.getElementById('fInStock').checked = false; applyFilters(); } });
            if (price !== 'all') {
                const pl = {
                    '0-25': 'Under $25', '25-50': '$25–$50', '50-100': '$50–$100', '100+': 'Over $100'
                };
                tags.push({ label: pl[price] || price, clear: () => { document.querySelector('input[name="fprice"][value="all"]').checked = true; applyFilters(); } });
            }
            sizes.forEach(sz => {
                tags.push({ label: `Size: ${sz}`, clear: () => { document.querySelector(`#fSizes input[value="${sz}"]`).checked = false; applyFilters(); } });
            });
            if (!tags.length) return;
            const div = document.createElement('div');
            div.className = 'active-filters';
            div.innerHTML = tags.map((t, i) => `<span class="filter-tag">${t.label}<button onclick="activeClearFns[${i}]()" aria-label="Remove filter">×</button></span>`).join('');
            document.querySelector('.col-sort-bar').insertAdjacentElement('afterend', div);
            window.activeClearFns = tags.map(t => t.clear);
        }

        function clearFilters() {
            document.querySelector('input[name="fcat"][value="all"]').checked = true;
            document.querySelector('input[name="fprice"][value="all"]').checked = true;
            document.getElementById('fInStock').checked = false;
            document.querySelectorAll('#fSizes input').forEach(i => i.checked = false);
            applyFilters();
        }

        function syncSort(sel) {
            // Sync both sort dropdowns
            document.getElementById('colSort').value = sel.value;
            document.getElementById('colSortDesktop').value = sel.value;
            applyFilters();
        }

        function toggleFilter(head) {
            head.parentElement.classList.toggle('closed');
            head.querySelector('.filter-arr').textContent = head.parentElement.classList.contains('closed') ? '+' : '−';
        }

        function toggleMobileFilters() {
            const sb = document.getElementById('colSidebar');
            const ov = document.getElementById('mobFilterOverlay');
            sb.classList.toggle('mob-open');
            ov.classList.toggle('on');
            if (sb.classList.contains('mob-open') && !sb.querySelector('.mob-close-btn')) {
                // already handled by CSS
            }
        }

        // Init filter arrows to show −
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.filter-head').forEach(h => {
                h.querySelector('.filter-arr').textContent = '−';
            });
        });

        /* ══════════════════════════════════════
           SEARCH PAGE LOGIC
        ══════════════════════════════════════ */
        function gotoSearchPage() {
            gotoPage('search');
            setTimeout(() => {
                const inp = document.getElementById('searchPageInput');
                if (inp) { inp.focus(); inp.select(); }
            }, 100);
            // Show all products by default
            doPageSearch('');
        }

        let _spt;
        function doPageSearch(v) {
            searchQuery = v.trim();
            document.getElementById('searchPageClear').style.display = v ? 'block' : 'none';
            clearTimeout(_spt);
            _spt = setTimeout(() => renderSearchPage(), 160);
        }

        function clearPageSearch() {
            document.getElementById('searchPageInput').value = '';
            searchQuery = '';
            document.getElementById('searchPageClear').style.display = 'none';
            renderSearchPage();
            document.getElementById('searchPageInput').focus();
        }

        function setSearchCat(cat, btn) {
            searchCatFilter = cat;
            document.querySelectorAll('.schip2').forEach(c => c.classList.remove('on'));
            btn.classList.add('on');
            renderSearchPage();
        }

        function renderSearchPage() {
            let list = [...PRODUCTS];
            if (searchCatFilter !== 'all') list = list.filter(p => p.cat === searchCatFilter);
            if (searchQuery) {
                const q = searchQuery.toLowerCase();
                list = list.filter(p => p.name.toLowerCase().includes(q) || p.desc.toLowerCase().includes(q) || p.cat.includes(q));
            }

            const meta = document.getElementById('searchPageMeta');
            if (searchQuery) {
                meta.textContent = `${list.length} result${list.length !== 1 ? 's' : ''} for "${searchQuery}"`;
            } else {
                meta.textContent = list.length + ' products';
            }

            const grid = document.getElementById('searchPageGrid');
            if (!grid) return;
            if (!list.length) {
                grid.innerHTML = `<div class="search-empty">No products found${searchQuery ? ' for "' + searchQuery + '"' : ''}</div>`;
                return;
            }
            grid.innerHTML = list.map((p, i) => {
                const eid = p.id.replace(/"/g, '&quot;');
                const alt2 = p.imgs[1] ? `<img src="${p.imgs[1]}" class="alt-img" alt="">` : '';
                const colorSwatches = p.colors.length > 1 ? `<div class="pcard-colors" style="display:flex;gap:4px;margin-top:4px;align-items:center">${p.colors.slice(0, 6).map(c => `<span title="${c.name}" style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${c.hex};border:1px solid rgba(0,0,0,.15);flex-shrink:0"></span>`).join('')}${p.colors.length > 6 ? `<span style="font-size:7px;color:var(--muted)">+${p.colors.length - 6}</span>` : ''}</div>` : '';
                const logoColorSwatches = p.logoColors && p.logoColors.length > 0 ? `<div class="pcard-logo-colors" style="display:flex;gap:4px;margin-top:3px;align-items:center"><span style="font-size:6px;letter-spacing:.15em;text-transform:uppercase;color:var(--muted);margin-right:2px">Logo:</span>${p.logoColors.slice(0, 6).map(c => `<span title="${c.name}" style="display:inline-block;width:8px;height:8px;border-radius:2px;background:${c.hex};border:1px solid rgba(0,0,0,.2);flex-shrink:0"></span>`).join('')}</div>` : '';
                return `<div class="pcard" style="animation-delay:${i * .025}s" onclick="openDetail('${eid}',this)">
      <div class="pcard-img" data-pid="${eid}">
        ${p.origRaw ? '<span class="sale-tag">Sale</span>' : ''}
        ${!p.isAvail ? '<div class="sold-veil">Sold Out</div>' : ''}
        <button class="pcard-wish ${wished.has(p.id) ? 'on' : ''}" onclick="event.stopPropagation();toggleWishCard('${eid}',this)">${wished.has(p.id) ? '♥' : '♡'}</button>
        ${visualEl(p, 0)}${alt2}
        ${p.isAvail ? `<button class="pcard-cta" onclick="event.stopPropagation();quickAdd('${eid}')">Add to Bag</button>` : ''}
      </div>
      <div class="pcard-info">
        <div class="pcard-name">${p.name}</div>
        <div class="pcard-price">${p.origRaw ? `<span class="sp">${fmtP(p.priceRaw)}</span><span class="op">${fmtP(p.origRaw)}</span>` : fmtP(p.priceRaw)}</div>
        ${colorSwatches}${logoColorSwatches}
      </div>
    </div>`;
            }).join('');
        }


        /* ══════════════════════════════════════
           VITALS CONFIG — edit to match your Shopify discount
        ══════════════════════════════════════
           VITALS INTEGRATION NOTES:
           - VITALS_THRESHOLD_USD: the cart subtotal (in USD) needed to unlock the discount
           - VITALS_DISCOUNT_USD: the discount value in USD
           - VITALS_CODE: the Shopify discount code created in your Shopify Admin
             (Shopify Admin → Discounts → Create discount → Amount off order)
           - The code is auto-applied via the /discount/ redirect at checkout
           - To use the actual Vitals app: install Vitals from Shopify App Store, create
             a "Spend X Get Y" promotion, and set VITALS_CODE to that promotion's code
        ══════════════════════════════════════ */
        const VITALS_THRESHOLD_USD = 100;  // ← $100 USD spend to unlock
        const VITALS_DISCOUNT_USD = 10;   // ← $10 USD off
        const VITALS_CODE = 'NWIO10';      // ← Shopify discount code

        // These will be recalculated in SHOP_CUR whenever rates load or currency changes
        let vitalsThresholdRaw = VITALS_THRESHOLD_USD;
        let vitalsDiscountRaw = VITALS_DISCOUNT_USD;

        async function fetchVitalsDiscount() {
            // Convert USD thresholds → the current display/checkout currency (cur.code).
            // Cart line priceRaw values come from the Cart API in cur.code (via @inContext),
            // so the threshold must be in the same currency for a correct comparison.
            // Using RATES[cur.code] (not RATES[SHOP_CUR]) ensures INR cart totals are
            // compared to an INR threshold, not a USD one.
            const displayRate = RATES[cur.code] || 1;
            vitalsThresholdRaw = VITALS_THRESHOLD_USD * displayRate;
            vitalsDiscountRaw = VITALS_DISCOUNT_USD * displayRate;
        }

        function updateVitalsWidget() {
            // cartRaw is in cur.code (checkout currency from Cart API via @inContext).
            // Fallback threshold/discount also use cur.code rate so units always match.
            const cartRaw = cartLines.reduce((s, i) => s + i.priceRaw * (i.qty || 1), 0);
            const threshold = vitalsThresholdRaw || (VITALS_THRESHOLD_USD * (RATES[cur.code] || 1));
            const discount = vitalsDiscountRaw || (VITALS_DISCOUNT_USD * (RATES[cur.code] || 1));
            const needed = Math.max(0, threshold - cartRaw);
            const pct = Math.min(100, Math.round((cartRaw / threshold) * 100));
            const done = cartRaw >= threshold;
            const circ = 125.66;
            const offset = circ - (pct / 100) * circ;

            const msgHTML = done
                ? '\uD83C\uDF89 Unlocked! <strong>' + fmtP(discount) + ' off</strong><br>Code <strong>' + VITALS_CODE + '</strong> auto-applied'
                : 'Spend <strong>' + fmtP(needed) + '</strong> more \u2192 get <strong>' + fmtP(discount) + ' off!</strong>';
            const msgClass = done ? 'vitals-msg done' : 'vitals-msg';

            function setRing(ringId, pctId, msgId, dotId) {
                const ring = document.getElementById(ringId);
                const pctEl = document.getElementById(pctId);
                const msgEl = document.getElementById(msgId);
                const dot = dotId ? document.getElementById(dotId) : null;
                if (ring) { ring.style.strokeDashoffset = offset; ring.classList.toggle('done', done); }
                if (pctEl) pctEl.textContent = pct + '%';
                if (msgEl) { msgEl.innerHTML = msgHTML; msgEl.className = msgClass; }
                if (dot) dot.classList.toggle('done', done);
            }

            const floatEl = document.getElementById('vitalsFloat');
            if (floatEl) {
                floatEl.style.display = cartLines.length ? 'flex' : 'none';
                setRing('vitalsRingFgFloat', 'vitalsPctFloat', 'vitalsMsgFloat', 'vitalsFloatDot');
            }

            const cartBar = document.getElementById('vitalsBarCart');
            if (cartBar) {
                cartBar.style.display = cartLines.length ? 'flex' : 'none';
                setRing('vitalsRingFgCart', 'vitalsPctCart', 'vitalsMsgCart', null);
            }
        }

        function _updateFloatPosition() {
            const f = document.getElementById('vitalsFloat');
            if (!f) return;
            f.classList.toggle('cart-open', document.getElementById('cartPanel').classList.contains('on'));
        }
        const _origToggleCart = toggleCart;
        toggleCart = function () { _origToggleCart(); setTimeout(_updateFloatPosition, 50); };

        /* ══════════════════════════════════════
           CART — ensureCart + setCur override
        ══════════════════════════════════════ */
        async function ensureCart() {
            if (cartId) return;
            // Inline country as a literal enum — @inContext does not support variable arguments
            const country = CURRENCY_COUNTRY[cur.code] || 'US';
            const d = await gql(
                `mutation @inContext(country:${country}){cartCreate{cart{id checkoutUrl}userErrors{field message}}}`,
                {}
            );
            if (d?.cartCreate?.cart) {
                cartId = d.cartCreate.cart.id;
                checkoutUrl = d.cartCreate.cart.checkoutUrl;
            }
        }

        const _origSetCur = setCur;
        setCur = function (code, sym, label) {
            const changed = cur.code !== code;
            // Reset cart when currency changes (new cart will be created with new @inContext country)
            if (changed && !cartLines.length) { cartId = null; checkoutUrl = null; }
            _origSetCur(code, sym, label); // updates cur, re-renders grid/cart/detail
            if (changed) {
                // Reload products from Shopify with new @inContext country so prices are in the new currency
                loadProducts(CURRENCY_COUNTRY[code] || 'US').then(() => {
                    renderGrid(activeFilter);
                    applyFilters();
                    renderSearchPage();
                    renderWishlist();
                    renderCartUI();
                    if (curId) {
                        const _p = PRODUCTS.find(x => x.id === curId);
                        if (_p) {
                            const priceEl = document.getElementById('dPrice');
                            if (priceEl) priceEl.innerHTML = _p.origRaw
                                ? `<span class="sale">${fmtP(_p.priceRaw)}</span><span class="orig">${fmtP(_p.origRaw)}</span>`
                                : `<span class="reg">${fmtP(_p.priceRaw)}</span>`;
                        }
                    }
                });
            }
            // Refresh vitals widget with new currency amounts
            fetchVitalsDiscount().then(updateVitalsWidget);
        };

        async function goCheckout() {
            const btn = document.getElementById('checkBtn');
            btn.disabled = true;
            btn.innerHTML = '<span class="spin"></span>Redirecting\u2026';

            if (!cartId) await ensureCart();

            if (!checkoutUrl && cartId) {
                const country2 = CURRENCY_COUNTRY[cur.code] || 'US';
                const d = await gql(
                    `query($id:ID!,$country:CountryCode!) @inContext(country:$country){cart(id:$id){checkoutUrl}}`,
                    { id: cartId, country: country2 }
                );
                checkoutUrl = d?.cart?.checkoutUrl;
            }

            if (!checkoutUrl) {
                toast('Checkout unavailable — try again');
                btn.disabled = false;
                btn.innerHTML = 'Checkout \u00B7 ' + fmtP(cartLines.reduce((a, i) => a + i.priceRaw * (i.qty || 1), 0));
                return;
            }

            // cartRaw is in cur.code; compare against threshold in the same currency.
            const cartRaw = cartLines.reduce((s, i) => s + i.priceRaw * (i.qty || 1), 0);
            const threshold = vitalsThresholdRaw || (VITALS_THRESHOLD_USD * (RATES[cur.code] || 1));
            const earned = cartRaw >= threshold;
            let url = checkoutUrl;

            if (earned) {
                try {
                    const u = new URL(url);
                    url = u.origin + '/discount/' + VITALS_CODE + '?redirect=' + encodeURIComponent(u.pathname + u.search);
                } catch (e) {
                    url += (url.includes('?') ? '&' : '?') + 'discount=' + VITALS_CODE;
                }
            }

            window.location.href = url;
        }

        const _baseRenderCart = renderCartUI;
        renderCartUI = function () { _baseRenderCart(); updateVitalsWidget(); };

        (function () { fetchVitalsDiscount(); })();